export const navigationOutline = {
	name: "navigation_outline",
	description:
		"creates a navigation outline of the main navigation sections on the page",
	parameters: {
		type: "object",
		properties: {},
	},
	required: [],
};
